import type { ButtonHTMLAttributes } from 'react';
import React, { useContext } from 'react';

import ButtonGroup from '@swf/components/ButtonGroup/ButtonGroup';
import StarsButton from '@swf/components/StarsButton/StarsButton';
import { useWizardNav } from '@swf/poker';

import { TXTCLI_Back, TXTCLI_Done, TXTCLI_Next } from './Buttons.messages.json';
import styles from './NewUser.scss';
import NewUserContext from './NewUserContext';

export enum ModalPagesRoutes {
  '#new-user-flow.step-1',
  '#new-user-flow.step-2',
  '#new-user-flow.step-3'
}

export const pageCount = Object.keys(ModalPagesRoutes).length / 2;

function Buttons() {
  const {
    state: { activePage }
  } = useContext(NewUserContext);

  const goTo = useWizardNav(activePage);
  const handleGoBack = () => {
    goTo(activePage - 1, ModalPagesRoutes[activePage - 1]);
  };
  const handleNext = () => {
    goTo(activePage + 1, ModalPagesRoutes[activePage + 1]);
  };
  const displayBackButton = activePage > 0;
  const isLastPage = activePage === pageCount - 1;
  const submitText = isLastPage ? TXTCLI_Done : TXTCLI_Next;
  const submitProps = isLastPage
    ? { type: 'submit' as ButtonHTMLAttributes<HTMLButtonElement>['type'] }
    : { onClick: handleNext };

  return (
    <ButtonGroup className={styles.buttons}>
      <div>
        {displayBackButton && (
          <StarsButton
            className={styles.back}
            onClick={handleGoBack}
            variant="tertiary"
            translation={TXTCLI_Back}
          />
        )}
      </div>
      <div>
        <StarsButton {...submitProps} translation={submitText} />
      </div>
    </ButtonGroup>
  );
}

export default Buttons;
